import axios from 'axios';
import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  APPROVE_LEAD_URL,
  GET_ENQUIRY_RESPONSES,
  get_headers,
  get_project_id,
  get_token,
  VIEW_ENTITY_TYPE_URL,
  GET_ENTITY_TYPE_FORMS,
  ENTITY_REGISTER,
  GET_LEAD_FORMS,
} from '@/utils/constants/constants.js';
import { validate_non_sub_zero_number } from "@/utils/validations/validate_inputs";
import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import LiveChat from '@/views/probaworkflows_base/management/leads_management/live_chat/LiveChat.vue';
import ShareFormsWithLead from '@/views/probaworkflows_base/management/leads_management/share_forms_with_lead/ShareFormsWithLead.vue';
import LeadsLogs from '@/views/probaworkflows_base/management/leads_management/leads_logs/LeadsLogs.vue';
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import UploadMeetingMinutes from "@/views/probaworkflows_base/management/customer_management/upload_meeting_minutes/UploadMeetingMinutes.vue";
import GenerateQuote from "@/views/probaworkflows_base/invoicing/generate_quote/GenerateQuote.vue";
import PaymentApproval from '@/views/probaworkflows_base/management/leads_management/payment_approval/PaymentApproval.vue';
import GenerateInvoice from "@/views/probaworkflows_base/invoicing/generate_invoice/GenerateInvoice.vue";
import QuestionnaireForm from '@/views/probaworkflows_base/management/leads_management/questionnaire_form/QuestionnaireForm.vue';
import VerificationOverview from '@/views/probaworkflows_base/management/trust_applications/verification_managment/verification_overview/VerificationOverview.vue';

export default {
  name: 'LeadResponses',
  components: {
    AICampusFooter,
    LiveChat,
    ShareFormsWithLead,
    LeadsLogs,
    UploadMeetingMinutes,
    GenerateQuote,
    GenerateInvoice,
    NavigationBackButton,
    PaymentApproval,
    QuestionnaireForm,
    VerificationOverview
  },
  mixins: [alert_mixin],
  data: () => ({
    active_tab: null,
    selected_dropdown: null,
    applicant_info_expanded: false,
    token: get_token(),
    headers: get_headers(),
    project_id: get_project_id(),
    enquiry_form_id: sessionStorage.getItem('enquiry_form_id'),
    tabs: ['Applicant Information', 'Meeting Minutes', 'Share Lead Questionnaire',
      'Quotation', 'Invoicing', 'Lead Questionnaire Form', 'Verification'],
    show_lead_responses: true,
    show_live_chat: false,
    is_loading: false,
    lead_responses: [],
    lead_messages: [],
    lead_name: '',
    admin_message: '',
    entity_type: [],
    form_list: [],
    entity_type_id: null,
    selected_form_id: null,
    lead_id: null,
    lead_forms: [],
    selected_lead_form_id: null,
    loading_lead_forms: false,
  }),
  created() {
    this.fetch_lead_responses();
  },
  mounted() {
    this.enquiry_form_id = sessionStorage.getItem('enquiry_form_id');
    this.lead_id = this.$route.query.lead_id;

    if (this.lead_id) {
      sessionStorage.setItem("lead_id", this.lead_id);
      sessionStorage.removeItem("application_form_id");
      sessionStorage.removeItem("entity_profile_id");
    }

    // Initialize with Applicant Information tab active
    if (this.tabs.length > 0) {
      this.active_tab = 'Applicant Information';
      this.selected_dropdown = 'Applicant Information';
    }
    this.fetch_entity_types();
    this.fetch_lead_questionnaire_forms();
  },
 computed: {
  lead_id() {
    // Get lead_id from route query
    return this.$route.query.lead_id || null;
  }
},

  methods: {
    get_tab_icon(tab_name) {
      const icons = {
        'Applicant Information': 'bi bi-person-vcard',
        'Meeting Minutes': 'bi bi-clock-history',
        'Share Lead Questionnaire': 'bi bi-share',
        'Quotation': 'bi bi-file-earmark-ruled',
        'Invoicing': 'bi bi-receipt',
        'Lead Questionnaire Form': 'bi bi-file-earmark-text',
        'Verification': 'bi bi-shield-check',
        'Lead Tracker': 'bi bi-graph-up'
      };

      return Reflect.get(icons, tab_name) || 'bi bi-folder';    
    },

    select_tab(tab) {
      this.active_tab = tab;
      this.selected_dropdown = tab;
    },

    convert_lead_to_applicant() {
      // basic validations
      if (!this.entity_type_id) {
        this.show_error('Please select an entity type');
        return;
      }
      if (!this.selected_form_id) {
        this.show_error('Please select a form');
        return;
      }

      // minimal payload for entity-only flow
      const payload = {
        entity_type_id: Number(this.entity_type_id),
        form_ids: [Number(this.selected_form_id)],
        lead_id: Number(this.$route.query.lead_id),
        ...(this.project_id ? { project_id: Number(this.project_id) } : {})
      };

      axios.post(ENTITY_REGISTER, payload, { headers: this.headers })
        .then((response) => {
          if (response.data) {
            this.show_success('Lead successfully converted to applicant');
            this.close_modal('convert_lead_to_applicant');
            this.entity_type_id = '';
            this.selected_form_id = '';
          }
        })
        .catch((error) => {
          this.show_error(error.response?.data?.message || 'Error creating applicant from lead');
          this.close_modal('convert_lead_to_applicant');
        });
    },

    toggle_tab_dropdown(dropdown) {
      if (this.selected_dropdown === dropdown) {
        this.selected_dropdown = null;
      } else {
        this.selected_dropdown = dropdown;
      }
    },


    set_active_tab(tab) {
      this.active_tab = tab;
    },

    get_forms() {
      this.form_list = [];

      axios
        .get(GET_ENTITY_TYPE_FORMS, {
          headers: this.headers,
          params: { entity_type_id: this.entity_type_id },
        })
        .then((response) => {
          const parsed_response = JSON.parse(response.data);

          if (parsed_response.data && parsed_response.data.length > 0) {
            this.form_list = parsed_response.data;
          }
        })
        .catch((error) => {
          this.show_error("Error getting forms: " + error);
        });
    },

      fetch_lead_questionnaire_forms() {
      const lead_id = this.$route.query.lead_id;
      if (!lead_id) {
        return;
      }

      this.loading_lead_forms = true;

      axios
        .get(GET_LEAD_FORMS, {
          headers: this.headers,
          params: { lead_id: lead_id }
        })
        .then(response => {
          if (response.data.status === 'success' && response.data.data.length > 0) {
            this.lead_forms = response.data.data;
            // Auto-select first form if available
            if (this.lead_forms.length > 0) {
              this.selected_lead_form_id = this.lead_forms[0].lead_form_id;
              sessionStorage.setItem("lead_form_id", this.selected_lead_form_id);
            }
          } else {
            this.lead_forms = [];
          }
        })
        .catch(error => {
          console.warn('Error loading questionnaire forms: ' + (error.response?.data?.message || error.message));
        })
        .finally(() => {
          this.loading_lead_forms = false;
        });
    },

    move_to_qualified_lead() {
      const lead_id = this.$route.query.lead_id;

      if (!lead_id) {
        this.show_error('No lead selected to approve.');
        return;
      }

      const payload = { lead_id };

      axios.post(APPROVE_LEAD_URL, payload, { headers: this.headers })
        .then(response => {
          const { status, message } = response.data;

          if (status === 'success') {
            this.show_success('Lead approved successfully.');
            this.$router.push({
              path: '/leads_management',
            });
          } else {
            this.show_error('Error approving lead: ' + (message || 'Unknown error'));
          }
        })
        .catch(error => {
          this.show_error('Error approving lead: ' + (error.response?.data?.message || 'An unexpected error occurred'));
        });
    },

    async fetch_entity_types() {
      this.entity_type = [];
      const project_id = parseInt(this.project_id, 10);

      if (!validate_non_sub_zero_number(project_id)) {
        this.show_error("Project Id must not be null");
        return;
      }

      try {
        let response = await axios.get(VIEW_ENTITY_TYPE_URL, {
          headers: this.headers,
          params: { project_id }
        });

        const response_data = response.data;
        if (response_data.status === "success") {
          this.entity_type = response_data.data.map(entity => ({
            id: entity.id,
            name: entity.entity_type_name,
            description: entity.entity_type_description
          }));
        } else {
          this.show_error("Error while retrieving entity types");
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.show_error(
            "Error while retrieving entity types: " + error.response.data.message
          );
        }
      }
    },

    fetch_lead_responses() {
      const lead_id = this.$route.query.lead_id;
      if (!lead_id) {
        this.show_error('No lead ID provided');
        this.is_loading = false;
        return;
      }

      this.is_loading = true;

      const params = {
        project_id: this.project_id,
        enquiry_form_id: this.enquiry_form_id
      };

      axios.get(GET_ENQUIRY_RESPONSES, { params: params, headers: this.headers })
        .then(response => {

          if (response.data.status === 'success') {
            const lead = response.data.data.find(lead => lead.lead_id == lead_id);

            if (lead) {
              this.lead_responses = Object.entries(lead.questions).map(([id, question]) => {
                
                // Parse choices if they're JSON strings
                let parsedChoices = question.choices;
                if (typeof parsedChoices === 'string') {
                  try {
                    parsedChoices = JSON.parse(parsedChoices);
                  } catch (e) {
                     this.show_error('Invalid choices format. Please check the data.');
                  }
                }
                
                // Parse answer if it's a JSON string
                let parsedAnswer = question.answer;
                if (typeof parsedAnswer === 'string') {
                  try {
                    parsedAnswer = JSON.parse(parsedAnswer);
                  } catch (e) {
                    // If parsing fails, keep as string
                  }
                }

                return {
                  id: parseInt(id),
                  ...question,
                  choices: parsedChoices,
                  answer: parsedAnswer
                };
              });


              const responses = this.lead_responses;
              const first_obj = responses.find(r =>
                r.question_text.toLowerCase().includes('first name')
              );
              const last_obj = responses.find(r =>
                r.question_text.toLowerCase().includes('last name')
              );
              if (first_obj && last_obj) {
                this.lead_name = `${first_obj.answer} ${last_obj.answer}`.trim();
              } else {
                const full_obj = responses.find(r =>
                  r.question_text.toLowerCase().includes('full name')
                );
                if (full_obj) {
                  this.lead_name = full_obj.answer;
                } else {
                  const any_name_obj = responses.find(r =>
                    r.question_text.toLowerCase().includes('name')
                  );
                  this.lead_name = any_name_obj?.answer || '';
                }
              }
            } else {
              this.show_error('Lead not found');
            }
          } else {
            this.show_error('Failed to load lead responses');
          }
        })
        .catch(error => {
          this.show_error(`Error fetching lead responses: ${error.response?.data?.message || error.message}`);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },

    has_options_or_answer(response) {
      // Check if we have choices or an answer to work with
      return (response.choices && response.choices.length > 0) || 
             (response.answer && response.answer.trim() !== '');
    },

    get_options_for_display(response) {
      // If we have choices, use them
      if (response.choices && response.choices.length > 0) {
        return this.get_options(response.choices);
      }
      
      // If no choices but we have an answer, generate options from the answer
      if (response.answer && response.answer.trim() !== '') {
        if (['single_select', 'radio'].includes(response.question_type)) {
          // For single select, create an array with just the answer
          return [{ value: response.answer, text: response.answer }];
        } else if (['multi_select', 'checkbox', 'checkboxes'].includes(response.question_type)) {
          // For multi-select, split by comma and create options
          const answers = response.answer.split(',').map(item => item.trim());
          return answers.map(answer => ({ value: answer, text: answer }));
        }
      }
      
      return [];
    },

    get_options(choices) {
      // Handle different formats of choices
      if (!choices) return [];

      // If choices is already an array
      if (Array.isArray(choices)) {
        // Check if first item has value/text structure or is just a string
        if (choices.length > 0 && typeof choices[0] === 'object' && choices[0].value !== undefined) {
          return choices;
        } else {
          // Convert string array to objects with value and text
          return choices.map(choice => ({
            value: choice,
            text: choice
          }));
        }
      }

      // If choices is a string, try to parse it
      if (typeof choices === 'string') {
        try {
          const parsed = JSON.parse(choices);
          if (Array.isArray(parsed)) {
            return this.get_options(parsed);
          }
        } catch (e) {
          // If it's a comma-separated string
          if (choices.includes(',')) {
            return choices.split(',').map(choice => ({
              value: choice.trim(),
              text: choice.trim()
            }));
          }
          // Single value
          return [{
            value: choices,
            text: choices
          }];
        }
      }

      return [];
    },

    is_option_selected(answer, optionValue) {
      if (!answer) return false;

      // Handle null/undefined
      if (answer === null || answer === undefined) return false;

      // Convert optionValue to string for comparison
      const optionStr = String(optionValue).trim();

      // If answer is an array
      if (Array.isArray(answer)) {
        return answer.some(ans => {
          const ansStr = String(ans).trim();
          return ansStr === optionStr;
        });
      }

      // If answer is a string
      if (typeof answer === 'string') {
        const answerStr = answer.trim();
        
        // For multi-select with comma-separated values
        if (answerStr.includes(',')) {
          const values = answerStr.split(',').map(v => v.trim());
          return values.includes(optionStr);
        }
        
        // For single select, direct comparison
        return answerStr === optionStr;
      }

      // For other types (numbers, objects)
      return String(answer).trim() === optionStr;
    },

    get_file_name(file_path) {
      if (!file_path) return 'Unknown file';

      // If it's a full URL or path, extract the filename
      if (typeof file_path === 'string') {
        const parts = file_path.split('/');
        return parts[parts.length - 1] || 'File';
      }

      // If it's an object with a name property
      if (file_path.name) {
        return file_path.name;
      }

      return 'File';
    },

    open_file_preview(file) {
      if (!file) {
        this.show_error('No file to preview');
        return;
      }

      // If file is a URL string
      if (typeof file === 'string') {
        window.open(file, '_blank');
      }
      // If file is an object with url property
      else if (file.url) {
        window.open(file.url, '_blank');
      }
      // If file is an object with path property
      else if (file.path) {
        window.open(file.path, '_blank');
      }
      else {
        this.show_error('Unable to open file preview');
      }
    },
  }
};